var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomersActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "events copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-41.000000, -352.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "events-copy-7",
    transform: "translate(41.000000, 352.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,8.57142857 L16.1,8.57142857 L16.1,10 L17.5,10 C18.6592702,10.0012991 19.5987269,10.9599283 19.6,12.1428571 L19.6,15 L21,15 L21,12.1428571 C20.9977627,10.171358 19.4320691,8.57371154 17.5,8.57142857 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,1.42857143 C17.259798,1.42857143 18.2,2.38796125 18.2,3.57142857 C18.2,4.75489589 17.259798,5.71428571 16.1,5.71428571 C14.940202,5.71428571 14,4.75489589 14,3.57142857 C14,2.38796125 14.940202,1.42857143 16.1,1.42857143 M16.1,-6.34413157e-16 C14.1670034,-6.34413157e-16 12.6,1.59898304 12.6,3.57142857 C12.6,5.54387411 14.1670034,7.14285714 16.1,7.14285714 C18.0329966,7.14285714 19.6,5.54387411 19.6,3.57142857 C19.6,2.62422682 19.2312511,1.71581999 18.5748737,1.04604721 C17.9184964,0.37627443 17.0282577,-6.34413157e-16 16.1,-6.34413157e-16 L16.1,-6.34413157e-16 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4,20 L14,20 L14,18.5714286 C13.9987269,17.3884998 13.0592702,16.4298705 11.9,16.4285714 L9.1,16.4285714 C7.94072977,16.4298705 7.0012731,17.3884998 7,18.5714286 L7,20 L5.6,20 L5.6,18.5714286 C5.6022758,16.5999457 7.16794683,15.0023222 9.1,15 L11.9,15 C13.8320532,15.0023222 15.3977242,16.5999457 15.4,18.5714286 L15.4,20 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,7.85714286 C11.659798,7.85714286 12.6,8.81653268 12.6,10 C12.6,11.1834673 11.659798,12.1428571 10.5,12.1428571 C9.34020203,12.1428571 8.4,11.1834673 8.4,10 C8.4,8.81653268 9.34020203,7.85714286 10.5,7.85714286 M10.5,6.42857143 C8.56700338,6.42857143 7,8.02755446 7,10 C7,11.9724455 8.56700338,13.5714286 10.5,13.5714286 C12.4329966,13.5714286 14,11.9724455 14,10 C14,9.05279825 13.6312511,8.14439142 12.9748737,7.47461864 C12.3184964,6.80484586 11.4282577,6.42857143 10.5,6.42857143 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,8.57142857 L3.5,8.57142857 C1.56794683,8.57375081 0.00227579696,10.1713743 3.10862447e-16,12.1428571 L3.10862447e-16,15 L1.4,15 L1.4,12.1428571 C1.4012731,10.9599283 2.34072977,10.0012991 3.5,10 L4.9,10 L4.9,8.57142857 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,1.42857143 C6.05979797,1.42857143 7,2.38796125 7,3.57142857 C7,4.75489589 6.05979797,5.71428571 4.9,5.71428571 C3.74020203,5.71428571 2.8,4.75489589 2.8,3.57142857 C2.8,2.38796125 3.74020203,1.42857143 4.9,1.42857143 M4.9,0 C2.96700338,0 1.4,1.59898304 1.4,3.57142857 C1.4,5.54387411 2.96700338,7.14285714 4.9,7.14285714 C6.83299662,7.14285714 8.4,5.54387411 8.4,3.57142857 C8.4,2.62422682 8.03125106,1.71581999 7.37487373,1.04604721 C6.71849641,0.37627443 5.82825771,0 4.9,0 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersActive);
export default __webpack_public_path__ + "static/media/customers-active.33d4ff7434d4967ac8995867a9d7d9ab.svg";
export { ForwardRef as ReactComponent };